import React from 'react';  
import './index.css';
 
class AttachList extends React.Component{
   downloadBtn(content,filename){
      let eleLink = document.createElement('a');
      eleLink.download = filename;
      eleLink.style.display = 'none';
      // 字符内容转变成blob地址
      let blob = new Blob([content]);
      eleLink.href = URL.createObjectURL(blob);
      // 触发点击
      document.body.appendChild(eleLink);
      eleLink.click();
      // 然后移除
      document.body.removeChild(eleLink);
  //  const path = this.props.data.get('path')
     // console.log(data.get('path'))
     // window.open(path);
     // https://codeload.github.com/douban/douban-client/legacy.zip/master
     // this.createIFram(path)
  }
// createIFram(url){
//   var myFrame= document.createElement('iframe'); 
//   myFrame.src = url; 
//   myFrame.style.display = 'none'; 
//   document.body.appendChild(myFrame);
// }
  static formatterDocSize(size){
    let res = '';
      switch (true) {
          case size<1024:
              res= size+"KB";
            break;
          case size===1024:
            res = '1MB';
            break;
          case size>1024&&size<1048576:
            res= (size/1024).toFixed(2)+'MB';
            break;
          case size===1048576:
            res= '1GB';
            break;
          case size>1048576&&size<1073741824:
            res= (size/(1024*1024)).toFixed(2)+"GB";
            break;
          default:
            res= "文件超过1G";
            break
      }
      return res
  }
 
  render(){
    const {data} =this.props;
    return( 
      <div>
        {
          data
          ?
          <div className="attach-list">
            <p className="list-icon">
              <img src={require('./img/list_icon.png')} alt=""/>
            </p>
            <div className="list-title">
             {data.get('title')?data.get('title'):'暂无'} 
            </div>
            <div className="list-kb">{data.get('size')?AttachList.formatterDocSize(data.get('size')):'暂无'}</div>
           {/*
            <a target="_blank"   href="http://source.vlab2.chinamcloud.com/uploads/2019/Jan/01/201901020936575c2c15b9b91cf.xls">课程导入状态_2017_01_12.xls</a>
           */} 
            <a href={data.get('path')}  download={data.get('title')?data.get('title'):''} className="list-btn" onClick={()=>{this.downloadBtn(data.get('path'),data.get('title'))}}>下载</a>
          </div>
          :
          null
        }
      </div>
      )
  }
}
export default AttachList;